/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

var fa=document.getElementsByClassName("collapsible_heading");
  var i;
  for( i=0;i<fa.length;i++){
    fa[i].addEventListener("click",function(){
        this.classList.toggle("active");
       var fa_answer=this.nextElementSibling;
     
        if( fa_answer.style.display=="block"){
            fa_answer.style.display="none";
        }
        else{
            fa_answer.style.display="block";}
    });
  }





// special offers


 document.addEventListener('cart:updated', (event) => {
    // if (document.querySelector('cart-drawer').dataset.autoAddFreeGift == 'true') {

    if(typeof handleFreeGiftsOnCartFetch !== "undefined"){
      handleFreeGiftsOnCartFetch();
    }
     
    // }
    handleSpecialProductAddToCart();
    updateCartItemVariant();
         if(document.querySelector('.special-offer-products')){
      
      setTimeout(function(){
        if(document.querySelector(".special-offer-products")?.querySelectorAll(".special-offer-item").length > 1){
            new window.ThemeFlickity(document.querySelector('.special-offer-products'), 
      JSON.parse(document.querySelector('.special-offer-products').getAttribute('flickity-config')));
        }
       
        document.querySelector('.special-offers-wrapper')?.removeAttribute("hidden");
        window.dispatchEvent(new Event('resize'));
      }, 1000);
     
      }
    
  });
// document.addEventListener('variant:added',  (event) => handleFreeGiftsOnCartFetch());
document.addEventListener("DOMContentLoaded", (event) => {
   // if (document.querySelector('cart-drawer').dataset.autoAddFreeGift == 'true') {
   //  handleFreeGiftsOnCartFetch();
   // }
   handleSpecialProductAddToCart();
  updateCartItemVariant();
  
});


function handleSpecialProductAddToCart() {

  document.querySelector('cart-drawer')?.addEventListener('click', e => {

    let currentTarget = e.target;
   
   if(currentTarget.hasAttribute('data-special-product-add-to-cart') || currentTarget.closest('[data-special-product-add-to-cart]')){

     let addToCartButton = currentTarget.closest(".special-offer-item").querySelector('[data-special-product-add-to-cart]');
     addToCartButton.setAttribute('aria-busy', true);
     addToCartButton.querySelector('.loader-button__loader').removeAttribute("hidden");
     let variantId = parseInt(addToCartButton.dataset.variantId, 10);
     let data = {
     id: variantId,
    quantity: 1
     };

    fetch(`${window.themeVariables.routes.rootUrl}cart/add.js`, {
      body: JSON.stringify(data),
      credentials: "same-origin",
      method: "POST",
      headers: {
          "Content-Type": "application/json"
      }
    }).then(response => response.json()).then(response => {

      
    fetch(`${window.themeVariables .routes.cartUrl}.js`).then(response => response.json()).then(cart => {
    document.querySelectorAll('.header__cart-count').forEach(item => item.innerHTML = cart.items.length);
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
    bubbles: true,
    detail: {
    cart: cart
    }
    }));
    });
    }).catch(error => {
     console.log(error);
     addToCartButton.removeAttribute('aria-busy');
      addToCartButton.querySelector('.loader-button__loader').setAttribute("hidden", "");
        
    });
    
   }
  });
  
}
function updateCartItemVariant() {

  document.querySelector('cart-drawer')?.addEventListener('change', e => {

    let currentTarget = e.target;
   
   if(currentTarget.hasAttribute('.cart-item-variants') || currentTarget.closest('.cart-item-variants')){

    let $lineItem = currentTarget.closest("line-item");
    let cartItemVariantsObj = $lineItem.querySelector('.cart-item-variants'); 
    let quantity = $lineItem.querySelector(".quantity-selector__input").value;
    let lineItemKey = $lineItem.dataset.itemKey;
    let updatedvariantId = cartItemVariantsObj.value;
   
    let data = {};
    data[lineItemKey] = 0;
    data[updatedvariantId] = quantity;

    $lineItem.dispatchEvent(new CustomEvent("line-item-quantity:change:start", { bubbles: true, detail: { newLineQuantity: quantity } }));
     
    fetch(`${window.themeVariables.routes.rootUrl}cart/update.js`, {
      body: JSON.stringify({updates: data}),
      credentials: "same-origin",
      method: "POST",
      headers: {
          "Content-Type": "application/json"
      }
    }).then(response => response.json()).then(response => {

    fetch(`${window.themeVariables .routes.cartUrl}.js`).then(response => response.json()).then(cart => {
    document.querySelectorAll('.header__cart-count').forEach(item => item.innerHTML = cart.items.length);
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
    bubbles: true,
    detail: {
    cart: cart
    }
    }));

    $lineItem.dispatchEvent(new CustomEvent("line-item-quantity:change:end", { bubbles: true, detail: { cart: cart, newLineQuantity: quantity } }));
    });
    }).catch(error => {
     console.log(error);
     $lineItem.dispatchEvent(new CustomEvent("line-item-quantity:change:end", { bubbles: true, detail: { cart: cart, newLineQuantity: quantity } }));
        
    });
    
   }
  });
  
}
window.handleSpecialProductAddToCart=handleSpecialProductAddToCart;



var productForm = document.getElementById(document.querySelector('product-media')?.getAttribute('form-id'));

productForm?.addEventListener("variant:change", async function(event){

  const variant = event?.detail?.variant;

let addToCartButtonElement = productForm.querySelector("[data-product-add-to-cart-button]");
if (!addToCartButtonElement) {
return;
}
let addToCartButtonText = "";
addToCartButtonElement.classList.remove("button--primary", "button--secondary", "button--ternary");
if (!variant) {
addToCartButtonElement.setAttribute("disabled", "disabled");
addToCartButtonElement.classList.add("button--ternary");
addToCartButtonText = window.themeVariables.strings.productFormUnavailable;
} else {
if (variant["available"]) {
addToCartButtonElement.removeAttribute("disabled");
addToCartButtonElement.classList.add(addToCartButtonElement.hasAttribute("data-use-primary") ? "button--primary" : "button--secondary");
addToCartButtonText = addToCartButtonElement.getAttribute("data-button-content");
} else {
addToCartButtonElement.setAttribute("disabled", "disabled");
addToCartButtonElement.classList.add("button--ternary");
addToCartButtonText = window.themeVariables.strings.productFormSoldOut;
}
}
if (addToCartButtonElement.getAttribute("is") === "loader-button") {
addToCartButtonElement.firstElementChild.innerHTML = addToCartButtonText;
} else {
addToCartButtonElement.innerHTML = addToCartButtonText;
}

const $productSection = document.querySelector('[data-product-section]');
const productUrl = $productSection.dataset.productUrl;
const sectionId = $productSection.dataset.section;

const requestUrl = `${productUrl}?variant=${variant?.id}&sections=${sectionId}`;

let response = await fetch(requestUrl);
response = await response.json();
let responseText = response[sectionId];

let html = new DOMParser().parseFromString(responseText, 'text/html');

let optionValueSelectors = document.querySelectorAll(`.product-form__option-value-${sectionId}`);

for(optionValueSelector of optionValueSelectors) {
 const id = optionValueSelector.getAttribute("id");
 const source = html.getElementById(`${id}`);
const destination = document.querySelector(`#${id}`);

if (source && destination) {
destination.innerHTML = source.innerHTML;
}
}
const priceSource =  html.querySelector(`#product-meta__price-list-container-${sectionId}`);
const priceDestination =  document.querySelector(`#product-meta__price-list-container-${sectionId}`);
if (priceSource && priceDestination) {
priceDestination.innerHTML = priceSource.innerHTML;
}
});
